import { DateTime } from "luxon";

export function formatDateFromISO(isoString: string): string {
  const date = DateTime.fromISO(isoString);
  return date.toFormat("dd-MM-yyyy");
}
